import React from 'react';

const SECTION_DESCRIPTIONS = {
  basicInformation: "Let's start with the basics - your name, contact info, and trip dates.",
  groupInfo: "Tell us about your travel party so we can plan accordingly.",
  parkTicketAccess: "Help us understand your ticket type and park access options.",
  parkVisitPlans: "Which parks would you like to visit and for how many days?",
  accommodation: "Where will you be staying and how will you get around?",
  attractionRideStrategy: "What's your approach to rides and attractions?",
  showFireworkStrategy: "Are you interested in shows and entertainment?",
  diningPreferences: "Let's plan your dining experiences.",
  timeEnergy: "When do you prefer to start your park days and take breaks?",
  specialConsiderations: "Any special occasions or accessibility needs?",
  specialtyExperiences: "Interested in premium or enchanted experiences?",
  budget: "Help us understand your budget preferences.",
};

const SectionHeader = ({ section, sectionIndex, totalSections, trackMode, isFastTrack }) => {
  const description = SECTION_DESCRIPTIONS[section.id] || "Complete this section to continue.";

  return (
    <div className="section-header-v2 mb-8">
      <div className="section-header-top flex justify-between items-center mb-3">
        <div className="section-step text-sm font-medium">
          {isFastTrack ? (
            <>Fast Track: Step {sectionIndex + 1} of {totalSections}</>
          ) : (
            <>Step {sectionIndex + 1} of {totalSections}</>
          )}
        </div>
        <div className="section-progress text-sm font-medium">
          {Math.round(((sectionIndex + 1) / totalSections) * 100)}% Complete
        </div>
      </div>
      <h2 className="section-title m-0 mb-2 text-3xl font-bold max-sm:text-2xl">{section.title}</h2>
      <p className="section-description m-0 text-base leading-normal">{description}</p>
    </div>
  );
};

export default SectionHeader;
